import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { EDSApplication as EDSApplicationBase } from '@ellucian/react-design-system/core';

const EDSApplication = React.memo(EDSApplicationBase);

const EDSContent = (props) => {
    const { theme, globalLocale, localeDirection, children } = props;
    const intl = useIntl();

    const overlappingDateText = intl.formatMessage({ id: 'overlappingDateRangeError' });
    const labelOverrides = useMemo(() => ({
        'component.DateRangePicker.error.overlappingDates': overlappingDateText,
    }), [overlappingDateText]);

    return (
        <EDSApplication
            theme={theme}
            locale={globalLocale}
            dir={localeDirection}
            labelOverrides={labelOverrides}
        >
            {children}
        </EDSApplication>
    );
};

export default EDSContent;